module.exports = ".custom-member-lookup>.ng-select-disabled::ng-deep .ng-value-label {\n    color: black !important;\n}"